module.exports = __webpack_public_path__ + "img/chargingstation-bestaand.ba284e25.svg";